<template>
  <dd-icon :icon="iconByDocument" size="md" style="margin-left: -4px"/>
</template>

<script>
import DocumentUtils from "~/util/document";

export default {
  name: "DocumentIconCell.vue",
  props: {
    row:{
      type: Object
    },
  },
  computed:{
    iconByDocument(){
      return DocumentUtils.getIconByDocument(this.row);
    },
  }
}
</script>
